import Container, { Service, Token } from 'typedi';
import { Lock } from '../utils/lockUtil';
import { BaseModuleLoader } from '../../loaders/BaseModuleLoader';
import { IClientIntegrationFacade } from './interfaces/IClientIntegrationFacade';
import { ClientProvider } from '../../models/enums/general-enums';
import { Utils } from '../utils';
import { ClientIntegrationFacadeToken } from '../../injection-tokens';

const moduleLock = new Lock();

@Service()
export class ClientIntegrationFacadeLoader extends BaseModuleLoader<IClientIntegrationFacade> {
    constructor() {
        super('ClientIntegrationFacadeLoader');
    }

    protected _createModuleInstance = async (): Promise<IClientIntegrationFacade> => {
        const clientProvider = Container.get(Utils).getClientProvider();

        switch (clientProvider) {
            case ClientProvider.Kambi: {
                const module = await import(
                    /* webpackChunkName: "client-integration-facade/kambi" */
                    './kambi-client-integration.facade'
                );
                return new module.KambiClientIntegrationFacade();
            }
            case ClientProvider.Poker: {
                const module = await import(
                    /* webpackChunkName: "client-integration-facade/poker" */
                    './poker-client-integration.facade'
                );
                return new module.PokerClientIntegrationFacade();
            }
            case ClientProvider.Spectate:
            default: {
                const module = await import(
                    /* webpackChunkName: "client-integration-facade/spectate" */
                    './spectate-client-integration.facade'
                );
                return new module.SpectateClientIntegrationFacade();
            }
        }
    };

    protected override _canUse: () => Promise<boolean> = async () => true;

    protected override _getModuleLock = (): Lock => moduleLock;
    protected override _getToken = (): Token<IClientIntegrationFacade> =>
        ClientIntegrationFacadeToken;
}
